// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"5e715a7a","477":"3ac1d3bd","998":"36e9592c"}[chunkId] + ".chunk.js";
};